import * as React from 'react';

export const BackIcon = () => {
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="24" 
            height="24" 
            viewBox="0 0 24 24">
            <path 
                className="icon-style"
                d="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"/>
        </svg>
        // <svg
        //     id="Layer_1"
        //     data-name="Layer 1"
        //     xmlns="http://www.w3.org/2000/svg"
        //     width="32"
        //     height="32"
        //     viewBox="0 0 32 32"
        // >
        //     <path
        //         className="icon-style"
        //         d="M5.71,13.62H20.57a5.73,5.73,0,0,1,5.72,5.71V26"
        //     />
        //     <polyline
        //         className="icon-style"
        //         points="13.43 6 5.81 13.62 13.43 21.24"
        //     />
        // </svg>
    );
};



// WEBPACK FOOTER //
// ./src/App/shared/icons/pt-icon-back.tsx